import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    commonStyles: {
      '&:hover': {
        background: '#E4E4E4',
      },
      background: '#EFEFEF',
      padding: '12px 16px',
      borderRadius: '4px',
      boxSizing: 'border-box',
      border: '1px solid rgba(0, 0, 0, 0.2275)',
    },

    blueBtn: {
      '&:hover': {
        background: '#248CE1',
      },
      background: '#3B97E3',
      color: '#FFFFFF',
    },

    small: {
      width: '80px',
      height: '44px',
    },

    medium: {
      width: '140px',
      height: '44px',
    },

    large: {
      width: '180px',
      height: '44px',
    },
  },
  {
    name: 'Button',
  },
);
